import cn from 'classnames';
import s from './FilterItem.module.scss';

export default function FilterItem({ active, children, ...props }) {
  const className = cn(s.wrapper, {
    [s.active]: active,
  });

  return (
    <div {...props} className={className} role="button">
      {children}
    </div>
  );
}
